import { Trans } from "react-i18next";

import user4 from "@/female/assets/reviews/4.webp";
import femaleUser1 from "@/female/assets/reviews/female-user1.png";
import femaleMuscleGain from "@/female/assets/reviews-goals/muscle-gain.webp";
import femaleMuscleGainMobile from "@/female/assets/reviews-goals/muscle-gain-mobile.webp";
import femaleWeightLoss from "@/female/assets/reviews-goals/weight-loss.webp";
import femaleWeightLossMobile from "@/female/assets/reviews-goals/weight-loss-mobile.webp";
import i18n from "@/localization/i18next";
import maleMuscleGain from "@/male/assets/old-funnel-test/reviews-goals/muscle_gain.webp";
import maleMuscleGainMobile from "@/male/assets/old-funnel-test/reviews-goals/muscle_gain_mobile.webp";
import maleWeightLoss from "@/male/assets/old-funnel-test/reviews-goals/weight_loss.webp";
import maleWeightLossMobile from "@/male/assets/old-funnel-test/reviews-goals/weight_loss_mobile.webp";
import user1 from "@/male/assets/reviews/1.png";
import user2 from "@/male/assets/reviews/2.png";
import user3 from "@/male/assets/reviews/3.svg";

import { FitnessGoals, goalTextById } from "./fitnessGoal";

export const getReviewByGoal = (isFemale: boolean) => ({
    [FitnessGoals.GainMuscle]: {
        img: isFemale ? femaleMuscleGain : maleMuscleGain,
        imgMobile: isFemale ? femaleMuscleGainMobile : maleMuscleGainMobile,
        promoTitle: (
            <Trans
                i18nKey="success_promo_title"
                values={{ peopleAmount: "101,516", goal: goalTextById.gainMuscle }}
            >
                <span className="mx-1 text-zing-warm-neon-green-500 female:text-zing-warm-tangerine-500"></span>
            </Trans>
        ),
        title: isFemale ? "Claire Ramsey" : "Nick Hughes",
        date: i18n.t("testimonial_date_2"),
        text: i18n.t("testimonial_content"),
    },
    [FitnessGoals.LoseWeight]: {
        img: isFemale ? femaleWeightLoss : maleWeightLoss,
        imgMobile: isFemale ? femaleWeightLossMobile : maleWeightLossMobile,
        promoTitle: (
            <Trans
                i18nKey="success_promo_title"
                values={{ peopleAmount: "124,843", goal: goalTextById.loseWeight }}
            >
                <span className="mx-1 text-zing-warm-neon-green-500 female:text-zing-warm-tangerine-500"></span>
            </Trans>
        ),
        title: isFemale ? "Kate Stafford" : "Adam  Stewart",
        date: i18n.t("testimonial_date"),
        text: i18n.t("testimonial_content"),
    },
    [FitnessGoals.GetActive]: {
        img: femaleWeightLoss,
        imgMobile: femaleWeightLossMobile,
        promoTitle: (
            <Trans
                i18nKey="success_promo_title"
                values={{ peopleAmount: "124,843", goal: goalTextById.loseWeight }}
            >
                <span className="mx-1 text-white female:text-zing-warm-tangerine-500"></span>
            </Trans>
        ),
        title: isFemale ? "Kate Stafford" : "Adam  Stewart",
        date: i18n.t("testimonial_date"),
        text: i18n.t("testimonial_content"),
    },
});

export const getReviews = (isFemale: boolean) => [
    {
        avatar: isFemale ? femaleUser1 : user1,
        name: isFemale ? "Judy Trevino" : "Albert Flores",
        training: isFemale ? i18n.t("2_weeks_training") : i18n.t("4_weeks_training"),
        text: isFemale ? i18n.t("2_weeks_testimonial") : i18n.t("4_weeks_testimonial"),
    },
    {
        avatar: user2,
        name: "Will Spencer",
        training: i18n.t("3_months_training"),
        text: i18n.t("3_months_testimonial"),
    },
    {
        avatar: isFemale ? user4 : user3,
        name: isFemale ? "Sarah Norman" : "Peter Norman",
        training: i18n.t("2_months_training"),
        text: i18n.t("2_months_testimonial"),
    },
];
